import { useQuery } from '@tanstack/react-query';
import { getUserById } from '@services/users.service';

export const USER_DETAIL_QUERY_KEY = (id) => ['users', 'detail', id];

export const useUserDetail = (userId) =>
    useQuery({
        queryKey: USER_DETAIL_QUERY_KEY(userId),
        queryFn: () => getUserById(userId),
        enabled: !!userId,
    });
